<a
  class="resources-item"
  [href]="resource.file ? resource.file?.url : resource.url"
  (click)="link ? '' : $event.preventDefault()"
  target="_blank" rel="noreferrer noopener"
  filePreview
  [type]="resource.file?.ext"
  [item]=""
  [disabledButtons]="['delete', 'move', 'rename']"
  [etag]="resource.file?.etag"
  [file]="resource.file"
  [prevent]="
    resource.company !== null &&
    link &&
    (resource.file_type == 1 ||
      resource.file_type == 2 ||
      resource.file_type == 4)
  "
  [resourceId]="resource.id"
>
  <div class="resources-thumb">
    <div class="resources-type text-center">
      <i
        class="feather"
        [ngClass]="{
          'external-link': resource.file_type == 5,
          image: resource.file_type == 4,
          play: resource.file_type == 3,
          'file-text': resource.file_type == 1 || resource.file_type == 2
        }"
        [attr.title]="resource.file_type == 5 ? 'External link' : null"
        [attr.title]="resource.file_type == 4 ? 'Image' : null"
        [attr.title]="resource.file_type == 3 ? 'Video' : null"
        [attr.title]="
          resource.file_type == 1 || resource.file_type == 2 ? 'Document' : null
        "
      ></i>
    </div>
  </div>
  <div class="resources-content">
    <div class="resources-content-wrapper">
      <div class="resources-title">{{ resource.name }}</div>
      <div class="resources-description">{{ resource.description }}</div>
    </div>
  </div>
</a>
